module.exports = __webpack_public_path__ + "svg_80x80/elixir.5020a3.svg";